module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('multiselect', {
    attrs: {
      "selectLabel": _vm.t('Select'),
      "selectGroupLabel": _vm.t('Select group'),
      "deselectLabel": _vm.t('Deselect'),
      "deselectGrouLabel": _vm.t('Deselect group'),
      "placeholder": _vm.placeholder,
      "options": _vm.options,
      "custom-label": _vm.searchLabel,
      "group-values": "rows",
      "group-label": "group",
      "group-select": true,
      "label": _vm.label,
      "multiple": true,
      "close-on-select": false
    },
    on: {
      "input": _vm.change
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('div', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v("\n            " + _vm._s(_vm.t('List is empty')) + "\n        ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7311ce5e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomCategory.vue
// module id = 1322
// module chunks = 2